<div class="full-height-container flex-column flex-centered flex-g-m">
  <h1>Oops..</h1>
  <span>The page you are trying to go to is not available.</span>
  <button (click)="this.onHomeClicked()" class="" color="primary" mat-raised-button>Go Home</button>
</div>
